import axios from 'axios';
import type { BulkSupraLockboxProcessedResult } from './bulkCreateShacklePermissions';

const bulkUnassignSupraLockboxes = async ({
  lockboxAssigneeMap,
}: {
  lockboxAssigneeMap: Record<string, string>;
}): Promise<BulkSupraLockboxProcessedResult> => {
  const { data } = await axios.post<BulkSupraLockboxProcessedResult>(
    '/supra/lockbox/bulk_unassign_lockboxes',
    {
      lockboxAssigneeMap,
    },
  );

  return data;
};

export default bulkUnassignSupraLockboxes;
